import { FlexRow, FuuzeButton, FuuzeDialogComponent, mediaQuery, useIsMobileAndTablet } from '@fuuze/shared';
import { useEffect, useState } from 'react';
import { IoClose, IoMenu } from 'react-icons/io5';
import styled from 'styled-components';
import { useStore } from '../../store/store';
import { SearchNavLink } from './links/nav-bar-search-link';
import { MenuContent } from './menu-content';
import styles from './nav-bar.module.css';
import { NavBarGetAppLink } from './nav-bar-get-app-link';

export function NavBar() {
  const isMobileAndTablet = useIsMobileAndTablet();
  const [menuOpen, setMenuOpen] = useState(false);
  const podcastSelected = useStore(state => state.podcastSelected);

  // Close the dialog in mobile when a podcast is selected in the podcast selector
  useEffect(() => {
    if (podcastSelected) {
      closeMenu();
    }
  }, [podcastSelected]);

  const closeMenu = () => {
    setMenuOpen(false);
  };

  const openOrCloseMenu = () => setMenuOpen(prev => !prev);

  if (isMobileAndTablet) {
    return (
      <Wrapper id='navigation-bar'>
        <SearchNavLink onClick={closeMenu}>
          <div style={{ height: '100%', display: 'grid', placeItems: 'center' }}>
            <Logo src='/images/logo.webp' />
          </div>
        </SearchNavLink>
        <FlexRow style={{ flex: 1, paddingRight: 8, justifyContent: 'flex-end', gap: 16, alignItems: 'center' }}>
          <NavBarGetAppLink />
          <SearchNavLink onClick={closeMenu} />
          <FuuzeDialogComponent
            RootProps={{
              modal: 'trap-focus',
              open: menuOpen,
            }}
            TriggerProps={{
              render: (
                <FuuzeButton icon onClick={openOrCloseMenu}>
                  {menuOpen ? <Icon as={IoClose} /> : <Icon as={IoMenu} />}
                </FuuzeButton>
              ),
            }}
            ScrollAreaContentProps={{ className: styles.DialogScrollAreaContent }}
            PopupProps={{ className: styles.DialogPopup }}
            BackdropProps={{ className: styles.DialogBackdrop }}
            scrollable
          >
            <MenuContent closeMenu={closeMenu} />
          </FuuzeDialogComponent>
        </FlexRow>
      </Wrapper>
    );
  }
  return (
    <Wrapper id='navigation-bar'>
      <Logo src='/images/logo.webp' />
      <MenuContentWrapper>
        <MenuContent closeMenu={closeMenu} />
      </MenuContentWrapper>
    </Wrapper>
  );
}

const Icon = styled.svg`
  width: 20px;
  height: 20px;

  @media ${mediaQuery.mobile} {
    width: 24px;
    height: 24px;
  }
`;

const Logo = styled.img`
  width: 64px;
  margin-left: 16px;

  @media ${mediaQuery.tablet} {
    width: 100px;
  }

  @media ${mediaQuery.desktop} {
    margin: 32px auto;
  }
`;

const Wrapper = styled.div`
  overflow-y: auto;
  display: flex;
  background-color: ${props => props.theme.colors.background};
  position: sticky;
  bottom: 0;
  width: 100%;
  z-index: 2;
  box-shadow: 0 -10px 20px -10px black;
  padding: 0 16px;
  min-height: ${props => props.theme.variables.navigationBarHeight};

  @media ${mediaQuery.desktop} {
    border-radius: 8px;
    box-shadow: none;
    padding: 16px;
    flex-direction: column;
    width: ${props => props.theme.variables.navigationBarWidth};
    height: 100%;
  }
`;

const MenuContentWrapper = styled.div`
  width: auto;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 0;
  position: relative;
`;
